class GiftDrawer extends HTMLElement {
  constructor() {
    super();
    this.backdrop = this.querySelector("#gift-backdrop");
    this.backdrop.addEventListener("click", () => {
      this.close.bind(this);
    });
    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
  }

  open() {
    console.log("open");
    document.body.classList.add("overflow-hidden");
    this.classList.add("active");
  }

  close() {
    console.log("close");
    this.classList.remove("active");
  }

  setActiveElement(element) {
    console.log("setActive");
    this.activeElement = element;
  }
}

customElements.define("gift-drawer", GiftDrawer);
